import React from "react";
import {
  required,
  ReferenceInput,
  SelectInput,
  Create,
  SimpleForm,
  TextInput
} from "react-admin";

const SportSeasonCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput label="Sport" source="sportCode" reference="sportCodes">
          <SelectInput
            optionText="label"
            optionValue="code"
            validate={[required()]}
          />
        </ReferenceInput>
        <TextInput source="seasonCode" validate={[required()]} />
      </SimpleForm>
    </Create>
  );
};

export default SportSeasonCreate;
